import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export const AvisoLegal = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-[#004534] mb-8 text-center">
            AVISO LEGAL
          </h1>
          
          <div className="bg-gray-50 rounded-3xl p-8 md:p-12 shadow-lg">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                Titularidad del sitio web
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                En cumplimiento con el deber de información establecido en la Ley 34/2002, de 11 de julio, 
                de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa 
                que el presente sitio web www.erbaservice.com es propiedad de:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Titular:</strong> Emilio José Bautista Santiago</li>
                <li><strong>Nombre comercial:</strong> ERBA Service</li>
                <li><strong>Domicilio:</strong> Calle Ntra. Señora de las Nieves, Edificio Piscis Local 4, C.P. 29770 Torrox (Málaga)</li>
                <li><strong>Correo electrónico:</strong> info@erbaservice.com</li>
                <li><strong>Teléfono:</strong> 644348937</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                Objeto del sitio web
              </h2>
              <p className="text-gray-700 leading-relaxed">
                El presente sitio web tiene como finalidad informar sobre los servicios de mantenimiento 
                y reparación de maquinaria agrícola y de jardinería que ofrece ERBA Service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                Condiciones de uso
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación 
                plena y sin reservas de las condiciones contenidas en este aviso legal.
              </p>
              <p className="text-gray-700 leading-relaxed">
                El usuario se compromete a utilizar el sitio web de forma diligente, lícita y conforme 
                a la ley, la moral, el orden público y las presentes condiciones.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                Propiedad intelectual e industrial
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Todos los contenidos del sitio web (textos, imágenes, logotipos, marcas, diseño gráfico, 
                estructura y código fuente) son propiedad de ERBA Service o de sus legítimos titulares. 
                Queda prohibida su reproducción, distribución o transformación sin autorización expresa del titular.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                Responsabilidad
              </h2>
              <p className="text-gray-700 leading-relaxed">
                ERBA Service no se responsabiliza de los posibles errores tipográficos, técnicos o de 
                actualización de los contenidos del sitio web, ni de los daños derivados del acceso o uso del mismo.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                Legislación aplicable y jurisdicción
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Las relaciones entre ERBA Service y los usuarios del sitio web se regirán por la 
                legislación española. Para la resolución de cualquier conflicto que pudiera derivarse 
                del acceso o uso del sitio, las partes se someten a los Juzgados y Tribunales de Málaga.
              </p>
            </section>
          </div>

          <div className="text-center mt-8">
            <button 
              onClick={() => window.history.back()}
              className="bg-[#16a34a] hover:bg-[#15803d] text-white px-8 py-3 rounded-full font-semibold transition-all"
            >
              Volver
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};